import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import ProjectMilestonesForm from "../../../pages/admin/project/project-details/components/ProjectMilestonesForm";

type ProjectMilestoneDrawerComponentProps = {
    handleClose: (open: boolean) => () => void;
}

const ProjectMilestoneForm: React.FC<ProjectMilestoneDrawerComponentProps> = ({ handleClose }) => {
    const drawer = useSelector((state: any) => state.drawer);

    return (
        <Box>
           {drawer.name === 'Add Milestones' &&  <ProjectMilestonesForm />}
        </Box>
    )
}

export default ProjectMilestoneForm